import { useState, useMemo, useCallback, ComponentProps } from 'react';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';
import { getTableConfigs } from 'RealmModule/components/SubscriptionRealm/tableConfigs';
import SandboxesTable from 'SandboxModule/components/SandboxesTable';
import RealmsSearchFilters from 'SandboxModule/components/RealmsSearchFilters';
import { useRealmTableBulkActionMenu } from 'SandboxModule/hooks/useRealmTableBulkActionMenu';
import { RealmTableView, RealmTypes } from 'RealmModule/constants/realm';
import { DEFAULT_REALM_TABLE_VIEW } from 'RealmModule/constants/realm';
import StandardPageHeader from 'components/StandardPageHeader';

const SubscriptionRealmsPageContainer = () => {
  const [subscriptionTableView, setSubscriptionTableView] =
    useState<RealmTableView>(DEFAULT_REALM_TABLE_VIEW);
  const [submittedSearch, setSubmittedSearch] = useState({
    searchText: '',
    submitCount: 0,
  });

  const tableConfig = useMemo(
    () => getTableConfigs({ variant: subscriptionTableView }),
    [subscriptionTableView],
  );

  const { openRealmTableBulkSelectMenu, checkedSandboxes, setCheckedSandboxesSet } =
    useRealmTableBulkActionMenu({
      realmType: RealmTypes.subscription,
      tableView: subscriptionTableView,
    });

  const onFiltersSubmit = useCallback(
    ({ searchText }: { searchText: string }) => {
      setSubmittedSearch((prev) => ({
        searchText,
        submitCount: prev.submitCount + 1,
      }));
      setCheckedSandboxesSet(new Set());
    },
    [setCheckedSandboxesSet],
  );

  const onModifyClick: ComponentProps<typeof SandboxesTable>['onModifyButtonClick'] = (e) => {
    openRealmTableBulkSelectMenu({ target: e.currentTarget });
  };

  return (
    <Box>
      <Helmet title="Subscriptions" />

      <StandardPageHeader
        title="Subscriptions"
        subtitle="Manage subscription-based realm environments"
        icon="Subscriptions"
        sx={{ mb: 6 }}
      />

      <RealmsSearchFilters realmType={RealmTypes.subscription} onSubmit={onFiltersSubmit} />

      <SandboxesTable
        tableConfig={tableConfig}
        sandboxTableView={subscriptionTableView}
        setSandboxTableView={setSubscriptionTableView}
        onModifyButtonClick={onModifyClick}
        checkedSandboxes={checkedSandboxes}
        setCheckedSandboxesSet={setCheckedSandboxesSet}
        realmType={RealmTypes.subscription}
        showFilter={false}
        searchText={submittedSearch.searchText}
        filtersSubmitCount={submittedSearch.submitCount}
      />
    </Box>
  );
};

export default SubscriptionRealmsPageContainer;
